<template>
  <div :class="$style.page_parts_modal_banner">
    <div :class="$style.modal_container" :style="{ background: bgColor }">
      <div :class="$style.image">
        <AtomsConsumerImage :src="bannerImage" alt="" :width="122" :height="122" />
      </div>
      <div :class="$style.content">
        <p :class="$style.title" :style="{ color: textColor, 'border-color': textColor }">{{ title }}</p>
        <div :class="$style.content_bottom">
          <p :class="$style.description" :style="{ color: textColor }" v-html="sanitizeHtmlContent(description)"></p>
          <AtomsConsumerButton :class="$style.button" @click.prevent="modalOpen = true"
            >詳しく&nbsp;&#043;</AtomsConsumerButton
          >
        </div>
      </div>
    </div>
    <MoleculesConsumerModal v-model="modalOpen" :overlay-background-color-hex="modalBgColor">
      <AtomsConsumerImage :src="modalImage" alt="" :class="$style.modal_image" />
      <AtomsConsumerImage :src="spModalImage ? spModalImage : ''" alt="" :class="$style.sp_modal_image" />
    </MoleculesConsumerModal>
  </div>
</template>

<script setup lang="ts">
import { sanitizeHtmlContent } from "@tential/ec-gql-schema/utils/functions/sanitize"

type Props = {
  bannerImage: string
  modalImage: string
  modalBgColor?: string
  textColor: string
  bgColor: string
  title?: string
  description?: string
  spModalImage?: string
}

withDefaults(defineProps<Props>(), {
  bannerImage: "",
  modalImage: "",
  spModalImage: "",
  title: "",
  description: "",
  bgColor: "",
  textColor: "",
  modalBgColor: "",
})

const modalOpen = ref(false)
</script>

<style scoped module lang="scss">
.page_parts_modal_banner {
  .modal_container {
    @include full-container-lg;
    display: flex;
    background: $black-5;
  }
  .image {
    width: 122px;
    height: 122px;
    @include sp {
      width: 122.5px;
      height: 122.5px;
    }
    > img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .content {
    @include more-sp {
      width: calc(100% - 152px);
      margin-left: 30px;
    }
    @include sp {
      width: calc(100% - 132.5px);
      margin-left: 20px;
    }
  }
  .title {
    padding-bottom: 5px;
    font-weight: bold;
    border-bottom: 1px solid #000;
    @include more-sp {
      font-size: $font-size-22;
    }
    @include sp {
      font-size: 0.7812rem;
    }
  }
  .description {
    @include more-sp {
      max-width: 442px;
      margin-top: 13px;
      font-size: $font-size-16;
    }
    @include sp {
      margin-top: 4.5px;
      font-size: $font-size-11;
    }
  }
  .content_bottom {
    @include more-sp {
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
    }
  }
  .button {
    display: block;
    padding: 15px 30px;
    font-weight: bold;
    background: #fff;
    margin-top: 13px;
    @include sp {
      margin-top: 2.5px;
      margin-left: auto;
      font-size: $font-size-11;
    }
  }
  .modal_image {
    @include sp {
      display: none;
    }
    width: 100%;
  }
  .sp_modal_image {
    @include more-sp {
      display: none;
    }
    width: 100%;
  }
}
</style>
